import { Row } from "../Row";
import { Section } from "../Section";
import { SectionHeader } from "../SectionHeader";

export const InsuranceLoading = () => {
  return (
    <Section ariaLabel="Insurance">
      <SectionHeader heading={"Insurance"} />
      <Row isLoading />
    </Section>
  );
};
